import { useGetAuxValueGroups } from '../../../../../../queries';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';
import { ControlledCheckboxAutoComplete } from 'components/shared/ControlledFields';
import { useFormContext } from 'react-hook-form';
import { onRemoveElement } from '../utils/onRemoveElement';
import { Box } from '@mui/material';

const AuxGroupSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control, setValue, watch } = useFormContext();
  const { data: auxGroups, isFetching } = useGetAuxValueGroups();

  return isFetching ? (
    <Skeleton />
  ) : (
    <Box>
      <ControlledCheckboxAutoComplete
        fullWidth
        name="auxiliary_group_list"
        label={t('auxValueGroup')}
        variant="outlined"
        options={auxGroups ?? []}
        control={control}
        idProperty="auxValueGroupId"
        labelProperty="name"
        allowItemRemoval
        onRemoveElement={(id) =>
          onRemoveElement(setValue, watch, 'auxiliary_group_list', id)
        }
      />
    </Box>
  );
};

export default AuxGroupSection;
